<div
  class="input-group"
  [ngClass]="props.inputClass"
  [class.is-invalid]="showError"
  [class.disabled]="formControl.disabled"
  >
  @if (props.value) {
    <span
      class="input-text ms-3"
      >
      {{ props.value }}
    </span>
  }
</div>
